import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { getForfaitsByMissionId } from '../../api/commande'
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import zIndex from '@material-ui/core/styles/zIndex';

const modalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
        borderRadius: '10px',
        border: 'none',
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
        fontFamily: 'Montserrat, sans-serif',
        maxHeight: '80vh',
        overflow: 'hidden',

    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        zIndex: 1001
    },
};

const headerStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#5BBCEA',
    padding: '20px',
    position: 'relative',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
};

const closeButtonStyle = {
    position: 'absolute',
    right: '15px',
    backgroundColor: 'transparent',
    padding: '0',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '35px',
    height: '35px',
    cursor: 'pointer',
    fontSize: '22px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
    transition: 'background-color 0.3s, color 0.3s',
};

const contentStyle = {
    padding: '20px',
    background: '#F7F8F8',
    overflowY: 'auto',
    maxHeight: 'calc(80vh - 60px)',
};






const ForfaitSupplementaireModal = ({ isOpen, onClose, missionId, marge }) => {
    const [chargementEnCours, setChargementEnCours] = useState(false)
    const token = useSelector((state) => state.auth.token);
    const [forfaits, setForfaits] = useState([])

    const { t } = useTranslation()
    const fetchForfaits = async (missionId) => {
        setChargementEnCours(true)
        try {
            const res = await getForfaitsByMissionId(missionId, token)
            setForfaits(res)
        } catch (error) {
            toast.error(t("transfer_request_err"), {
                style: {
                    fontFamily: 'Montserrat',
                },
            });
        } finally {
            setChargementEnCours(false)
        }
    }
    const getForfaitDetails = (forfait) => {
        switch (forfait.type) {
            case 'kilometrage':
            case 'kilometrage_etage':
                return (
                    <>
                        <strong style={{ marginLeft: "1rem" }}>{t("mileage")} :</strong> <span style={{ color: '#FF5A5F' }}>{forfait.details?.kilometrage ?? 'N/A'} km</span>
                        <strong style={{ marginLeft: "1rem" }}>{t("floors")} :</strong> <span style={{ color: '#FF5A5F' }}>{forfait.details?.etages ?? '0'}</span>
                    </>
                );
            case 'heure':
            case 'heure_etage':
                return (
                    <>

                        <strong style={{ marginLeft: "1rem" }}>{t("hours")} :</strong> <span style={{ color: '#FF5A5F' }}>  {forfait.details?.heures ?? 'N/A'}</span>
                        <strong style={{ marginLeft: "1rem" }}>{t("floors")} :</strong> <span style={{ color: '#FF5A5F' }}>{forfait.details?.etages ?? '0'}</span>

                    </>
                );
            case 'etage':
                return (
                    <>
                        <strong style={{ marginLeft: "1rem" }}>{t("floors")} :</strong> <span style={{ color: '#FF5A5F' }}>{forfait.details?.etages ?? '0'}</span>
                    </>
                );
            case 'forfait_gratuit':
                return (
                    <>
                        <strong style={{ marginLeft: "1rem" }}>{t("hours")} :</strong> <span style={{ color: '#FF5A5F' }}>  {forfait.details?.heures ?? 'N/A'}</span>
                    </>
                )

            default:
                return (
                    <span>
                        {t("no_details")}
                    </span>
                );
        }
    };
    const getForfaitLabel = (type) => {
        switch (type) {
            case 'kilometrage':
                return t("mileage");
            case 'kilometrage_etage':
                return t("mileage&floors");
            case 'heure':
                return t("extra_hours");
            case 'heure_etage':
                return t("hours&floors");
            case 'etage':
                return t("floors");
            case 'forfait_gratuit':
                return t("free_package");
            default:
                return type;
        }
    };
    useEffect(() => {
        if (missionId && isOpen) {
            fetchForfaits(missionId)
        }
    }, [missionId, isOpen])
    const [isSmallScreen, setSmallScreen] = useState(() => window.innerWidth < 768);


    useEffect(() => {
        const checkIfMobile = () => {
            setSmallScreen(window.innerWidth < 768);
        };
        window.addEventListener('resize', checkIfMobile);

        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            ariaHideApp={false}
            style={{
                content: { width: isSmallScreen ? "90%" : "70%", ...modalStyles.content },
                overlay: modalStyles.overlay

            }}
        >
            <div style={headerStyle}>
                <h3 style={{ color: 'white', margin: 0, flex: 1, textAlign: 'center' }}>{t("additional_packages")}</h3>
                <button
                    onClick={onClose}
                    style={closeButtonStyle}
                >
                    X
                </button>
            </div>
            {chargementEnCours ?
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'white',
                        marginTop: "2rem",
                        marginBottom: "2rem"
                    }}
                >
                    <div className='customLoader'></div>
                </div>
                :
                <div style={contentStyle}>
                    {forfaits?.length === 0 ?
                        <div style={{
                            background: '#fff',
                            padding: '15px',
                            borderRadius: '8px',
                            marginBottom: '15px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            transition: 'transform 0.2s',
                            textAlign: 'center'
                        }}>
                            {t("no_additional_packages")}
                        </div>
                        :
                        forfaits?.map((forfait, index) => (
                            <div key={index}
                                style={{
                                    background: '#fff',
                                    padding: '15px',
                                    borderRadius: '8px',
                                    marginBottom: '15px',
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                    transition: 'transform 0.2s',
                                }}>
                                <span style={{
                                    fontWeight: 'bold',
                                    color: '#25A6E4',
                                    fontSize: '16px',
                                }}>
                                    {t("package")} N° {index + 1} {' '}{getForfaitLabel(forfait.type)}
                                </span>
                                <div style={{
                                    marginBottom: '8px',
                                    marginTop: '1rem',
                                    fontSize: '14px',
                                    color: '#838EAB',
                                }}>
                                    <span>  {getForfaitDetails(forfait)}</span>
                                    <strong style={{ marginLeft: "1rem" }}>{t("price")} :</strong> <span style={{ color: '#FF5A5F' }}>{((forfait?.prix) - ((forfait?.prix) * (marge ?? 0)) / 100).toFixed(2)} € </span>

                                </div>

                            </div>
                        ))}
                </div>
            }
        </Modal>
    );
};

export default ForfaitSupplementaireModal;
